import AccountCircle from '@material-ui/icons/AccountCircle';
import Lock from '@material-ui/icons/Lock';
import ThumbsUpDown from '@material-ui/icons/ThumbsUpDown';
import VerifiedUser from '@material-ui/icons/VerifiedUser';
import OndemandVideo from '@material-ui/icons/OndemandVideo';
import SettingsBackupRestore from '@material-ui/icons/SettingsBackupRestore';
import Home from '@material-ui/icons/Home';
import Add from '@material-ui/icons/Add';
import People from '@material-ui/icons/People';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Close from '@material-ui/icons/Close';
import DirectionsWalk from '@material-ui/icons/DirectionsWalk';
import MoreVert from '@material-ui/icons/MoreVert';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Delete from '@material-ui/icons/Delete';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ZoomIn from '@material-ui/icons/ZoomIn';
import ZoomOut from '@material-ui/icons/ZoomOut';

export {
    AccountCircle,
    Lock,
    ThumbsUpDown,
    VerifiedUser,
    OndemandVideo,
    SettingsBackupRestore,
    Home,
    Add,
    People,
    ArrowBack,
    Visibility,
    VisibilityOff,
    ChevronRight,
    Close,
    DirectionsWalk,
    MoreVert,
    AttachFileIcon,
    Delete,
    ExpandMore,
    ZoomIn,
    ZoomOut
};